import { render, staticRenderFns } from "./ConfigExpandedModel.vue?vue&type=template&id=7dd01679&scoped=true"
import script from "./ConfigExpandedModel.vue?vue&type=script&lang=js"
export * from "./ConfigExpandedModel.vue?vue&type=script&lang=js"
import style0 from "./ConfigExpandedModel.vue?vue&type=style&index=0&id=7dd01679&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd01679",
  null
  
)

export default component.exports